import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getClipVideosByStream = createAsyncThunk("clipVideosList/getClipVideosByStream", async (payload) => {
  try {
    const response = await magnifiAPI.getClipVideosByStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteClipVideoById = createAsyncThunk("clipVideosList/deleteClipVideoById", async (payload) => {
  try {
    const response = await magnifiAPI.deleteClipVideoById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const clipVideoBulkDownload = createAsyncThunk("clipVideosList/clipVideoBulkDownload", async (payload) => {
  try {
    const response = await magnifiAPI.clipVideoBulkDownload(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const clipVideoBulkDelete = createAsyncThunk("clipVideosList/clipVideoBulkDelete", async (payload) => {
  try {
    const response = await magnifiAPI.clipVideoBulkDelete(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
